// src/components/LandingPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import CarouselWithDots from './CarouselWithDots';
import './LandingPage.css';
import katalogImage1 from '../assets/foto1.JPG'; // Import gambar dari folder assets
import katalogImage2 from '../assets/foto2.JPG'; // Import gambar dari folder assets
import katalogImage3 from '../assets/foto3.JPG'; // Import gambar dari folder assets
import katalogImage4 from '../assets/foto4.JPG'; // Import gambar dari folder assets

const LandingPage = () => {
    return (
        <div className="landing-page">
            {/* Carousel */}
            <div className="carousel-container">
                <CarouselWithDots />
                {/* Landing Content */}
                <div className="landing-content">
                    <h1>Discover Your Style</h1>
                    <p>
                        Find the perfect essential menswear collection with <strong>Mein</strong>.
                    </p>
                    <a href="https://shopee.co.id/mein.essential" target="_blank" rel="noopener noreferrer" className="landing-button">Shop Now</a>
                </div>
            </div>

            {/* New Section: First Release Product */}
            <section className="product-release">
                <div className="product-release-content">
                    <h2>First Release: The Essential Collection</h2>
                    <p>
                        Be the first to get our exclusive release. The Essential Collection features timeless designs with high-quality fabrics.
                    </p>
                    <Link to="/product" className="product-button">Detail Product</Link>
                </div>
                <div className="product-release-images">
                    <div className="product-release-image">
                        <img src={katalogImage1} alt="First Release Product 1" className="product-image" />
                    </div>
                    <div className="product-release-image">
                        <img src={katalogImage2} alt="First Release Product 2" className="product-image" />
                    </div>
                    <div className="product-release-image">
                        <img src={katalogImage3} alt="First Release Product 3" className="product-image" />
                    </div>
                    <div className="product-release-image">
                        <img src={katalogImage4} alt="First Release Product 4" className="product-image" />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;
